/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Action_ListedInputs */

const en_recipe_action_listed = /** @type {(inputs: Recipe_Action_ListedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On list`)
};

const de_recipe_action_listed = /** @type {(inputs: Recipe_Action_ListedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Liste`)
};

/**
* | output |
* | --- |
* | "On list" |
*
* @param {Recipe_Action_ListedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_action_listed = /** @type {((inputs?: Recipe_Action_ListedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Action_ListedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_action_listed(inputs)
	return en_recipe_action_listed(inputs)
});